import { useState } from "react";
import { X, Pencil, Check } from "lucide-react";

const pad = (n) => String(n).padStart(2, "0");

export function RoomList({ rooms, onRename, onRemove }) {
  const [editing, setEditing] = useState(null);
  const [draft, setDraft] = useState("");
  const commitRename = (i) => {
    const v = draft.trim();
    if (v) onRename(i, v);
    setEditing(null);
  };
  const remove = onRemove;
  return (
    <div className="border border-stone-200 bg-white/60">
      <div className="flex items-center justify-between px-4 py-2 border-b border-stone-200">
        <div className="eyebrow">Spaces in this project</div>
        <div className="font-mono-lab text-xs text-stone-500" data-testid="room-total">{rooms.length} {rooms.length === 1 ? "space" : "spaces"}</div>
      </div>
      {rooms.length === 0 ? (
        <div className="px-4 py-6 text-sm text-stone-400" data-testid="room-list-empty">No spaces yet — tap a room above or add your own.</div>
      ) : (
        <ol className="divide-y divide-stone-100" data-testid="room-list">
          {rooms.map((r, i) => (
            <li key={`${r}-${i}`} className="flex items-center gap-3 px-4 py-2 text-sm group" data-testid={`room-item-${i}`}>
              <span className="font-mono-lab text-xs text-stone-400 w-6">{pad(i + 1)}</span>
              {editing === i ? (
                <>
                  <input autoFocus value={draft} onChange={e => setDraft(e.target.value)} onKeyDown={e => { if (e.key === "Enter") commitRename(i); if (e.key === "Escape") setEditing(null); }}
                    className="flex-1 border-b border-black bg-transparent outline-none py-0.5" data-testid={`room-rename-input-${i}`} />
                  <button type="button" onClick={() => commitRename(i)} className="p-1 hover:text-black text-stone-500" data-testid={`room-rename-save-${i}`}><Check size={14} /></button>
                </>
              ) : (
                <>
                  <span className="flex-1" data-testid={`room-name-${i}`}>{r}</span>
                  <button type="button" onClick={() => { setEditing(i); setDraft(r); }} className="p-1 text-stone-400 opacity-0 group-hover:opacity-100 hover:text-black transition-opacity" data-testid={`room-rename-${i}`} aria-label="Rename"><Pencil size={13} /></button>
                </>
              )}
              <button type="button" onClick={() => remove(i)} className="p-1 text-stone-400 hover:text-black" data-testid={`room-remove-${i}`} aria-label="Remove"><X size={14} /></button>
            </li>
          ))}
        </ol>
      )}
    </div>
  );
}
